import SwitchSelector from "./SwitchSelector";

export default SwitchSelector;
